import React, { Component } from 'react'
import Header from '../Header'
import './XXXIIIs.css'

class XXXIIIs extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXXXIIIs">
                    <p className="textXXXIII">2024, Paris, France, 2 - 18 août. A venir</p>
                </div>
            </div>
        )
    }
}

export default XXXIIIs